<template>
  <div class="flex items-center space-x-2">
    <input
      type="number"
      :value="displayValue"
      @input="onNumberInput"
      :min="1"
      :disabled="disabled"
      class="w-24 border border-gray-300 dark:bg-gray-600 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
    />
    <select
      :value="unit"
      @change="onUnitChange"
      :disabled="disabled"
      class="w-28 border border-gray-300 dark:bg-gray-600 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50"
    >
      <option value="seconds">seconds</option>
      <option value="minutes">minutes</option>
      <option value="hours">hours</option>
    </select>
  </div>
</template>

<script>
const UNIT_TO_SECONDS = { seconds: 1, minutes: 60, hours: 3600 };

function pickUnit(totalSeconds) {
  if (!totalSeconds) return "minutes";
  if (totalSeconds % 3600 === 0) return "hours";
  if (totalSeconds % 60 === 0) return "minutes";
  return "seconds";
}

export default {
  name: "DurationInput",
  props: {
    modelValue: { type: [Number, null], default: null },
    disabled: { type: Boolean, default: false },
  },
  emits: ["update:modelValue"],
  data() {
    return { unit: pickUnit(this.modelValue) };
  },
  computed: {
    displayValue() {
      if (this.modelValue == null) return "";
      return Math.round(this.modelValue / UNIT_TO_SECONDS[this.unit]);
    },
  },
  watch: {
    modelValue(newVal) {
      // If the parent resets the value (e.g. checkbox un-ticked), and the new
      // value is null, leave the unit alone so the user's unit choice sticks.
      if (newVal != null) this.unit = pickUnit(newVal);
    },
  },
  methods: {
    onNumberInput(e) {
      const raw = e.target.value;
      if (raw === "") return this.$emit("update:modelValue", null);
      const n = parseInt(raw, 10);
      if (isNaN(n) || n < 1) return this.$emit("update:modelValue", null);
      this.$emit("update:modelValue", n * UNIT_TO_SECONDS[this.unit]);
    },
    onUnitChange(e) {
      const newUnit = e.target.value;
      // Preserve the user's typed number, re-scale to the new unit.
      const current = this.displayValue === "" ? 0 : this.displayValue;
      this.unit = newUnit;
      if (current) {
        this.$emit("update:modelValue", current * UNIT_TO_SECONDS[newUnit]);
      }
    },
  },
};
</script>
